var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00034 8.34464C7.31034 8.34464 6.75034 7.78464 6.75034 7.09464C6.75034 6.40464 7.31034 5.84464 8.00034 5.84464C8.69034 5.84464 9.25034 6.40464 9.25034 7.09464C9.25034 7.78464 8.69034 8.34464 8.00034 8.34464ZM8.03067 3.64464C6.11517 3.62964 4.52517 5.17964 4.50017 7.09464C4.49517 7.62464 4.60017 8.12464 4.80517 8.57464C4.88017 8.74964 4.97517 8.90964 5.07517 9.06964C5.12517 9.14464 5.17567 9.22464 5.22017 9.30964L7.26067 12.9046C7.26067 12.9046 7.44567 13.3496 8.00017 13.3496C8.00017 13.3496 8.15567 13.3846 8.39017 13.2596C8.56517 13.1646 8.70017 13.0196 8.80067 12.8446L10.8007 9.27464C10.8452 9.19964 10.8902 9.11964 10.9402 9.04964C11.0352 8.89964 11.1202 8.73964 11.1957 8.57464C11.3902 8.13964 11.5002 7.65464 11.5002 7.14464C11.5002 5.21964 9.95017 3.65964 8.03067 3.64464Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.134ae1b1ec3d85811839a00a8451af6e.svg";
export { ForwardRef as ReactComponent };